<template>
    <div class="container">
        <div class="row justify-content-md-center">
            <div class="col col-lg-2">
            </div>
            <div class="col-md-auto">
                <team-form ref="teamForm" v-bind:orgName="this.name" v-bind:orgTeamKey="this.teamKey" v-bind:disabledTeamKey="this.disabledTeamKey" @save-team-data="saveTeamData" />
            </div>
            <div class="col col-lg-2">
            </div>
        </div>
    </div>
</template>

<script>
import Team from '../models/Team.js'
import TeamForm from '../components/TeamForm.vue'

export default {
    components: {
        TeamForm
    },
    props: {
        ownerId: String,
        disabledTeamKey: Boolean
    },
    data: function() {
        return {
            team: null,
            name: null,
            teamKey: null
        }
    },
    methods: {
        saveTeamData: function(name, teamKey) {
            console.info('emit name : ' + name)
            console.info('emit teamKey : ' + teamKey)
            this.name = name
            this.teamKey = teamKey

            // データ更新
            if (! this.team) {
                this.team = new Team()
            }

            this.team.ownerId = this.ownerId
            this.team.name = name
            this.team.teamKey = teamKey;

            if (this.team.timestamp) {
                this.team.update()
            }
            else {
                this.team.register()
            }

            this.$router.push(`/cal/${this.ownerId}`)
        },
    },
    created: async function() {
        let team = await Team.findByOwnerId(this.ownerId)
        
        if (team) {
            this.team = team
            this.name = team ? team.name : null
            this.teamKey = team ? team.teamKey : null
            this.$refs.teamForm.setDefaultData(this.name, this.teamKey)
        }
    },
}
</script>
